import banner from '@/dto/banner'

export default function () {
    return {
        banner: Object.assign({}, banner),
        success: false,
        customToolbar: [
            ["bold", "italic", "underline"],
            [
                {list: "ordered"},
                {list: "bullet"}
            ],
            ["image"],
            [{ 'size': ['small', false] }]
        ],
        errors: {
            title: null,
            text: null,
            image: null,
            gradient: null
        }
    }
}
